import React, { useState } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Input, Button, Checkbox, message } from 'antd';
import 'antd/dist/antd.css';
import { cloudFunctions } from '../../config/Fire';

const FormCreateResto = () => {

    const [form] = Form.useForm();
    const [checkRestoExists, setCheckRestoExists] = useState(false);
    const [advertising, setAdvertising] = useState(false);
    const [isRegistering, setIsRegistering] = useState(false);

    const handleSubmit = values => {
        if(values.password.length >= 6) {
            const data = {
                email: values.email,
                name: values.name,
                password: values.password,
                checkRestoExists: checkRestoExists,
                restaurantId: values.restaurantId,
                advertising: advertising,
            }
            submit(data);
        } else {
            message.error("La contraseña debe tener al menos 6 caracteres.");
        }
    };

    const submit = data => {
        setIsRegistering(true)
        cloudFunctions.createNewRestaurant({ 
            email: data.email,
            password: data.password,
            name: data.name,
            createResto: !data.checkRestoExists,
            restaurantId: data.restaurantId,
            advertising: data.advertising,
        })
        .then(response => {
            if(response.data.code === 0) {
                message.success('El Restó se cargó exitosamente.');
                this.handleReset();
                setIsRegistering(false)
            } else {
                message.error('Se produjo un error. Por favor, revise los campos.');
                setIsRegistering(false)
            }
            console.log(response);
        })
        .catch(err => {
            message.error('Se produjo un error. Por favor, vuelva a intentarlo más tarde.');
            console.log(err);
            setIsRegistering(false)
        });
    };

    const handleChangeRestoExists = e => {
        if(e.target.checked) {
            form.validateFields(['nickname'], { force: true });
        } else {
            form.resetFields(['restaurantId'])
            form.validateFields(['nickname'], { force: false });
        }
        setCheckRestoExists(e.target.checked)
    };

    const handleReset = () => {
        setCheckRestoExists(false)
        setAdvertising(false)
        form.resetFields();
    };

    return (
        <Grid className="gridCont">
            <Form onFinish={handleSubmit} form={form}>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="email" rules={[ { type: 'email', message: 'El E-mail no es válido', }, { required: true, message: 'Por favor, ingresa el e-mail del restaurante',},]}>
                            <Input placeholder="E-mail"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item name="name" rules={[{ required: true, message: 'Por favor, ingresa el nombre del restaurante', },]}>
                            <Input placeholder="Nombre"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="password" rules={[{ required: true, message: 'Por favor, ingresa la contraseña del restaurante', }]}>
                            <Input.Password placeholder="Contraseña"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Row start="xs">
                            <Col xs={12}>
                                <Form.Item>
                                    <Checkbox checked={advertising} onChange={e => setAdvertising(e.target.checked)} disabled={checkRestoExists}>Restaurante sólo para publicidad</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="restaurantId" rules={[{ required: checkRestoExists, message: 'Por favor, ingresa el id del restaurante', },]}>
                            <Input disabled={!checkRestoExists} placeholder="Restaurante ID"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Row start="xs">
                            <Col xs={12}>
                                <Form.Item>
                                    <Checkbox checked={checkRestoExists} onChange={handleChangeRestoExists}>El restaurante ya existe</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                    <Row center="xs">
                        <Col xs={6} sm={6} md={6}>
                            <Form.Item>
                            {
                                isRegistering ?
                                    <Button type="primary" htmlType="submit" disabled={true} loading>
                                        Registrar
                                    </Button>
                                    :
                                    <Button type="primary" htmlType="submit" disabled={false}>
                                        Registrar
                                    </Button>
                            }
                            </Form.Item>
                        </Col>
                        <Col xs={6} sm={6} md={6}>
                            <Form.Item>
                                <Button onClick={handleReset}>
                                    Limpiar campos
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
            </Form>
        </Grid>
    );
}

FormCreateResto.propTypes = {
};

export default FormCreateResto;